var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-tabs",class:{ 'cf-c-tabs--full-height': _vm.fullHeight }},[_c('div',{staticClass:"cf-c-tabs__items"},[_vm._t("tabs")],2),_c('div',{staticClass:"cf-c-tabs__content",attrs:{"id":"tab-content"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }